/**
 * Shared atmosphere values. The scene fog and the bloom pass both need the
 * same fog range: emissive surfaces deep in the fog must not bloom through it.
 */
import { rangeFogFactor } from 'three/tsl'

export const FOG_RANGE = { near: 9, far: 40 } as const

/** 0 near the camera, 1 fully lost in the void. Evaluate inside a scene material. */
export const voidFogFactor = () => rangeFogFactor(FOG_RANGE.near, FOG_RANGE.far)
